import React, { useState } from "react"

import { useTranslation } from "react-i18next"

import {Modal} from "components/modals/Modal"

import { AdminPlayerBonus2 } from "services/bonus/type"

import { formatDateTime } from "util/formatter"

interface ExtendSpinsModalProps {
  target: AdminPlayerBonus2
  onClose: () => void
  onExtend: (additionalDays: number) => void
}

export const ExtendSpinsModal: React.FC<ExtendSpinsModalProps> = ({ target, onClose, onExtend }) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const [additionalDays, setAdditionalDays] = useState(7)

  const inputClassName = "w-full input input-bordered bg-[rgba(0,0,0,0.05)] dark:bg-[rgba(0,0,0,0.2)]"
  const labelClassName = "label-text dark:text-gray-300"

  return (
    <Modal open={true} handler={onClose}>
      <div className="modal-box w-full max-w-md">
        <h3 className="text-lg font-bold dark:text-white mb-4">{t("bonus2.spins.extendFreeSpinsExpiration")}</h3>

        <div className="space-y-4">
          <div className="bg-base-200 dark:bg-[#0C0C1A] rounded-lg p-3">
            <div className="text-gray-500 dark:text-gray-400 text-sm">{t("bonus2.spins.player")}</div>
            <div className="dark:text-white font-semibold">{target.user_id}</div>
          </div>

          <div className="bg-base-200 dark:bg-[#0C0C1A] rounded-lg p-3">
            <div className="text-gray-500 dark:text-gray-400 text-sm">{t("bonus2.spins.currentExpiration")}</div>
            <div className="text-yellow-500 dark:text-yellow-400 font-semibold">
              {target.free_spins_expires_at ? formatDateTime(target.free_spins_expires_at) : (t("bonus2.spins.noExpirySet") as string)}
            </div>
          </div>

          <div className="form-control">
            <label className="label">
              <span className={labelClassName}>{t("bonus2.spins.additionalDays")}</span>
            </label>
            <input
              type="number"
              min={1}
              value={additionalDays}
              onChange={(e) => setAdditionalDays(parseInt(e.target.value) || 7)}
              className={inputClassName}
            />
          </div>

          <div className="modal-action">
            <button type="button" onClick={onClose} className="btn btn-secondary">
              {t("bonus2.spins.cancel")}
            </button>
            <button onClick={() => onExtend(additionalDays)} disabled={additionalDays <= 0} className="btn btn-success">
              Extend by {additionalDays} Days
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
